if (!customElements.get('sc-popup')) {
  customElements.define(
    'sc-popup',
    class ScPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.key = this.dataset.key;
        this.section = this.closest('.shopify-section');

        this.dialog.addEventListener('click', (event) => {
          // A click on the backdrop lands on the dialog itself, outside the inner panel.
          if (event.target === this.dialog || event.target.closest('[data-sc-popup-close]')) this.close();
        });
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });
        this.querySelector('[data-sc-popup-done]')?.addEventListener('click', () => this.remember('done'));
        // An announcement bar message set to "Clicking opens the sign-up popup".
        this.onOpener = (event) => {
          if (!event.target.closest('[data-sc-popup-open]')) return;
          event.preventDefault();
          this.open();
        };
        document.addEventListener('click', this.onOpener);

        if (window.Shopify?.designMode) {
          this.onSelect = (event) => event.target === this.section && this.open();
          this.onDeselect = (event) => event.target === this.section && this.close();
          document.addEventListener('shopify:section:select', this.onSelect);
          // A settings change re-renders the section while it is selected: keep it open.
          document.addEventListener('shopify:section:load', this.onSelect);
          document.addEventListener('shopify:section:deselect', this.onDeselect);
          return;
        }

        const params = new URLSearchParams(window.location.search);
        if (params.get('customer_posted') === 'true') {
          // Signed up, here or in the footer: never ask again.
          this.remember('done');
          if (window.location.hash === '#ScPopupForm' && this.querySelector('[data-sc-popup-success]')) this.open();
          return;
        }
        if (window.location.hash === '#ScPopupForm' && this.querySelector('[role="alert"]')) {
          this.open();
          return;
        }
        if (this.dataset.enabled !== 'true' || !this.isDue()) return;
        this.timer = setTimeout(() => this.open(), Number(this.dataset.delay || 0) * 1000);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('click', this.onOpener);
        if (this.onSelect) {
          document.removeEventListener('shopify:section:select', this.onSelect);
          document.removeEventListener('shopify:section:load', this.onSelect);
          document.removeEventListener('shopify:section:deselect', this.onDeselect);
        }
      }

      read() {
        try {
          return JSON.parse(localStorage.getItem(this.key)) || {};
        } catch (e) {
          return {};
        }
      }

      remember(state) {
        try {
          localStorage.setItem(this.key, JSON.stringify({ state, at: Date.now() }));
        } catch (e) {
          // Storage blocked: the popup may show again next visit.
        }
      }

      isDue() {
        const saved = this.read();
        if (saved.state === 'done') return false;
        if (saved.state === 'closed') return Date.now() - saved.at > Number(this.dataset.days || 7) * 86400000;
        return true;
      }

      open() {
        if (this.dialog.open) return;
        this.lastFocus = document.activeElement;
        this.dialog.showModal();
        this.dialog.querySelector('input[type="email"], [data-sc-popup-close]')?.focus({ preventScroll: true });
        document.body.classList.add('sc-popup-open');
      }

      close() {
        if (!this.dialog.open) return;
        this.dialog.close();
        document.body.classList.remove('sc-popup-open');
        if (!window.Shopify?.designMode && this.read().state !== 'done') this.remember('closed');
        this.lastFocus?.focus?.({ preventScroll: true });
      }
    }
  );
}
